// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `table {
  width: 100%;
}

mat-paginator {
  width: 100%;
}

.compact {
  height: 38px !important;
}

.compact mat-cell,
.compact mat-cell-header {
  font-size: 10pt;
}

.samples-table td.mat-mdc-cell {
  cursor: cell;
  -webkit-user-select: none;
          user-select: none;
  border: 2px solid transparent;
  padding: 4px 8px;
  box-sizing: border-box;
}
.samples-table td.mat-mdc-cell.selected {
  background-color: rgba(51, 144, 255, 0.1);
}
.samples-table td.mat-mdc-cell.selection-top {
  border-top-color: rgba(51, 144, 255, 0.8);
}
.samples-table td.mat-mdc-cell.selection-bottom {
  border-bottom-color: rgba(51, 144, 255, 0.8);
}
.samples-table td.mat-mdc-cell.selection-left {
  border-left-color: rgba(51, 144, 255, 0.8);
}
.samples-table td.mat-mdc-cell.selection-right {
  border-right-color: rgba(51, 144, 255, 0.8);
}`, "",{"version":3,"sources":["webpack://./src/app/components/data/inspect/samples/samples.component.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;AACF;;AAEA;EACE,WAAA;AACF;;AAEA;EACE,uBAAA;AACF;;AAEA;;EAEE,eAAA;AACF;;AAIE;EACE,YAAA;EACA,yBAAA;UAAA,iBAAA;EACA,6BAAA;EACA,gBAAA;EACA,sBAAA;AADJ;AAGI;EACE,yCAAA;AADN;AAKI;EACE,yCAAA;AAHN;AAKI;EACE,4CAAA;AAHN;AAKI;EACE,0CAAA;AAHN;AAKI;EACE,2CAAA;AAHN","sourcesContent":["table {\n  width: 100%;\n}\n\nmat-paginator {\n  width: 100%;\n}\n\n.compact {\n  height: 38px !important;\n}\n\n.compact mat-cell,\n.compact mat-cell-header {\n  font-size: 10pt;\n}\n\n// Spreadsheet-style selection\n.samples-table {\n  td.mat-mdc-cell {\n    cursor: cell;\n    user-select: none;\n    border: 2px solid transparent;\n    padding: 4px 8px;\n    box-sizing: border-box;\n\n    &.selected {\n      background-color: rgba(51, 144, 255, 0.1);\n    }\n\n    // Selection borders - only show on edges\n    &.selection-top {\n      border-top-color: rgba(51, 144, 255, 0.8);\n    }\n    &.selection-bottom {\n      border-bottom-color: rgba(51, 144, 255, 0.8);\n    }\n    &.selection-left {\n      border-left-color: rgba(51, 144, 255, 0.8);\n    }\n    &.selection-right {\n      border-right-color: rgba(51, 144, 255, 0.8);\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
